import {useCmsApi} from '~/composables/core/http.js';

export function useSurfaceEditorCmsApi() {
  const apiPaths = {
    fonts: '/jupiter-google-fonts',
    colors: '/design-color'
  };

  return {
    async getGoogleFonts() {
      const data = await useCmsApi().fetch(
        apiPaths.fonts,
        {
          params: {
            query: {global: true}
          }
        }
      );

      return data.fonts;
    },
    getColors() {
      return useCmsApi().fetch(apiPaths.colors);
    }
  }
}
